<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'app',
  created() {
    // 새로고침 시 세션 스토리지에 유저 정보가 있다면 복구
    const userInfo = this.$session.get("userInfo");
    if (userInfo) {
      this.$store.commit('RESTORE_USER_INFO', userInfo);
    }
  }
}
</script>

<style lang="scss">
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
</style>
<style>
  /* Import Bootstrap Vue Styles */
  @import 'bootstrap-vue/dist/bootstrap-vue.css';
  @import "bootstrap/dist/css/bootstrap.css";
  /* import "bootstrap-vue/dist/bootstrap-vue.css"; */
</style>
<style lang="scss">
  // Import Main styles for this application
  @import './assets/scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue